import { render, staticRenderFns } from "./businesses.vue?vue&type=template&id=25311e93"
import script from "./businesses.vue?vue&type=script&lang=js"
export * from "./businesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports